var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPresentationHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 457,
    viewBox: "0 0 526 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.415 243.551C479.415 246.275 477.516 247.431 475.122 246.028L356.816 177.752C354.422 176.431 352.523 173.046 352.523 170.322V71.2523C352.523 68.5278 354.422 67.372 356.816 68.7755L475.122 137.051C477.516 138.455 479.415 141.757 479.415 144.481V243.551Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.754 134.987L360.448 66.6291C359.292 65.9686 358.219 65.886 357.476 66.2988L353.926 68.3628C354.669 67.95 355.742 68.0325 356.898 68.693L475.204 136.969C477.598 138.29 479.497 141.674 479.497 144.399V243.469C479.497 244.789 479.084 245.698 478.341 246.193L481.643 244.294C482.551 243.881 483.047 242.891 483.047 241.405V142.335C483.047 139.693 481.065 136.308 478.754 134.987Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.122 137.051L356.816 68.693C354.422 67.2895 352.523 68.4453 352.523 71.1697V75.9581L479.415 149.187V144.399C479.415 141.757 477.516 138.372 475.122 137.051Z",
    fill: "#C0162E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.982 71.6652L360.367 73.6466V77.5268L356.982 75.628V71.6652Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M363.586 75.5453L366.971 77.4441V81.3244L363.586 79.4255V75.5453Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.191 79.343L373.576 81.2419V85.2046L370.191 83.2232V79.343Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M387.446 105.927L361.688 91.0662V86.2778L387.446 101.138V105.927Z",
    fill: "#C0162E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M474.545 169.661L370.191 109.394V107L474.545 167.267V169.661Z",
    fill: "#C0162E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 175.193L357.477 107.578V105.266L474.544 172.881V175.193Z",
    fill: "#C0162E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 180.807L357.477 113.192V110.798L474.544 178.413V180.807Z",
    fill: "#C0162E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 186.338L357.477 118.723V116.412L474.544 184.027V186.338Z",
    fill: "#C0162E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 191.952L357.477 124.337V121.943L474.544 189.558V191.952Z",
    fill: "#C0162E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 197.484L357.477 129.869V127.557L474.544 195.172V197.484Z",
    fill: "#C0162E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 203.098L357.477 135.482V133.088L474.544 200.703V203.098Z",
    fill: "#C0162E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 208.629L357.477 141.014V138.702L474.544 206.317V208.629Z",
    fill: "#C0162E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M474.544 214.243L357.477 146.628V144.234L474.544 211.849V214.243Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M418.239 187.329L357.477 152.159V149.848L418.239 184.935V187.329Z",
    fill: "#C0162E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.648 225.219C150.502 223.98 147.778 223.402 144.971 223.402H120.203V235.869H144.971C147.778 235.869 150.502 235.291 152.648 234.052C154.795 232.814 155.786 231.245 155.786 229.677C155.786 228.026 154.712 226.457 152.648 225.219Z",
    fill: "url(#paint1_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.24 194.177C247.094 192.938 244.369 192.36 241.562 192.36H173.947V204.827H241.562C244.369 204.827 247.094 204.249 249.24 203.01C251.387 201.772 252.377 200.203 252.377 198.635C252.377 197.066 251.304 195.415 249.24 194.177Z",
    fill: "url(#paint2_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M197.561 209.698C195.414 208.459 192.69 207.881 189.883 207.881H147.035V220.348H189.883C192.69 220.348 195.414 219.77 197.561 218.531C199.707 217.293 200.698 215.724 200.698 214.156C200.698 212.505 199.707 210.936 197.561 209.698Z",
    fill: "url(#paint3_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M516.896 328.499C517.227 328.168 517.639 327.921 518.052 327.756H523.171L525.317 323.05L523.418 322.72C522.841 322.637 522.18 322.472 521.602 322.142C520.942 321.812 520.529 321.234 520.529 320.573C520.611 319.913 520.611 319.335 520.529 318.674C520.446 317.353 522.098 316.693 523.418 316.445L525.4 316.115L523.171 311.409H518.052C517.887 311.327 517.722 311.244 517.557 311.162C517.309 310.996 517.061 310.831 516.896 310.666C516.401 310.088 515.823 309.593 515.245 309.015C514.089 307.859 514.915 306.786 515.823 306.291L517.227 305.465L511.282 301.998L509.879 302.823C508.971 303.318 507.155 303.814 505.173 303.153C504.265 302.823 503.357 302.493 502.366 302.245C502.036 302.163 501.706 301.998 501.458 301.832C500.302 301.172 500.22 300.264 500.55 299.686L501.045 298.53L492.955 297.292L492.459 298.448C492.129 299.191 490.973 300.099 488.662 300.099C487.588 300.099 486.515 300.099 485.442 300.099C484.203 300.099 483.295 299.851 482.717 299.521C482.139 299.191 481.809 298.778 481.644 298.448L481.149 297.292L473.058 298.53L473.553 299.686C473.884 300.429 473.719 301.585 471.737 302.245C470.746 302.493 469.838 302.823 468.93 303.153C466.949 303.814 465.132 303.318 464.224 302.823L462.821 301.998L456.877 305.465L458.28 306.291C459.188 306.786 460.096 307.859 458.858 309.015C458.28 309.51 457.702 310.088 457.207 310.666C456.051 311.822 454.07 311.905 452.831 311.739L450.85 311.409L448.703 316.115L450.685 316.445C451.263 316.528 451.923 316.693 452.501 317.023C453.161 317.353 453.574 317.931 453.574 318.592C453.492 319.252 453.492 319.83 453.574 320.491C453.574 320.986 453.409 321.399 453.079 321.729H439.787V327.756H451.015H456.134C456.299 327.838 456.464 327.921 456.629 328.003C456.877 328.168 457.124 328.334 457.289 328.499C457.785 329.077 458.363 329.572 458.941 330.15C459.188 330.398 459.353 330.563 459.436 330.81H451.593V337.167H463.234V336.837L464.224 336.259C465.132 335.764 466.949 335.268 468.93 335.929C469.26 336.094 469.673 336.177 470.003 336.342V341.791H481.149H481.231L481.727 340.635C481.727 340.552 481.809 340.47 481.892 340.387V341.791H493.12L501.21 340.552L500.715 339.396C500.385 338.736 500.467 337.745 501.953 337.085H511.448L517.392 333.617L515.988 332.792C515.08 332.296 514.172 331.223 515.41 330.067C515.906 329.572 516.401 329.077 516.896 328.499ZM497.825 325.857C491.881 329.324 482.139 329.324 476.113 325.857C470.086 322.389 470.086 316.775 476.03 313.308C481.974 309.841 491.716 309.841 497.743 313.308C503.77 316.775 503.77 322.389 497.825 325.857Z",
    fill: "url(#paint4_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M489.237 289.614C489.155 289.779 489.072 290.027 489.072 290.192V300.346C489.072 300.099 489.155 299.934 489.237 299.769L489.733 298.613V288.458L489.237 289.614Z",
    fill: "#BDBDBD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M462.157 289.614L461.662 288.458V298.613L462.157 299.769C462.24 299.934 462.323 300.181 462.323 300.429V290.274C462.323 290.027 462.24 289.779 462.157 289.614Z",
    fill: "#BDBDBD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M504.593 296.219C504.015 296.549 503.438 297.127 503.438 297.787V307.942C503.438 307.281 504.015 306.703 504.593 306.373L505.997 305.548V295.393L504.593 296.219Z",
    fill: "#BDBDBD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M446.886 296.219L445.482 295.393V305.548L446.886 306.373C447.464 306.703 448.042 307.281 448.042 307.942V297.787C448.124 297.127 447.546 296.549 446.886 296.219Z",
    fill: "#BDBDBD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M512.188 306.291C510.95 306.456 509.381 307.116 509.299 308.437V318.592C509.299 317.271 510.95 316.61 512.188 316.445L514.17 316.115V305.96L512.188 306.291Z",
    fill: "#BDBDBD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M442.262 310.171V308.52C442.262 307.777 441.766 307.281 441.188 306.951C440.61 306.621 439.95 306.456 439.372 306.373L437.391 306.043V316.198L439.372 316.528C439.95 316.61 440.61 316.776 441.188 317.106C441.684 317.436 442.096 317.849 442.262 318.427V319.582C442.262 319.913 442.262 320.243 442.262 320.573V310.419C442.262 310.336 442.262 310.253 442.262 310.171Z",
    fill: "#BDBDBD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M514.17 312.895V323.05L512.023 327.756V317.601L514.17 312.895Z",
    fill: "#BDBDBD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M439.702 317.601L439.619 327.756L437.473 323.05V312.895L439.702 317.601Z",
    fill: "#BDBDBD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M510.124 317.271C508.886 317.106 506.904 317.188 505.749 318.344C505.253 318.922 504.758 319.417 504.097 319.995C503.685 320.408 503.52 320.821 503.52 321.151V331.306C503.52 330.975 503.685 330.563 504.097 330.15C504.675 329.655 505.253 329.077 505.749 328.499C506.904 327.343 508.886 327.26 510.124 327.426L512.106 327.756V317.601L510.124 317.271Z",
    fill: "#CACACB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M447.629 319.995C447.051 319.5 446.473 318.922 445.978 318.344C445.812 318.096 445.565 317.931 445.317 317.849C444.161 317.188 442.675 317.188 441.602 317.353L439.703 317.684V327.838L441.602 327.508C442.593 327.343 444.161 327.343 445.317 328.003C445.565 328.169 445.812 328.334 445.978 328.499C446.473 329.077 447.051 329.572 447.629 330.15C448.042 330.563 448.207 330.976 448.207 331.306V321.151C448.207 320.821 448.042 320.408 447.629 319.995Z",
    fill: "#CACACB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M506.161 323.545V333.7L500.217 337.085V327.013L506.161 323.545Z",
    fill: "#BDBDBD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M451.591 327.013V337.085L445.646 333.7V323.545L451.591 327.013Z",
    fill: "#BDBDBD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M498.814 326.187C497.906 325.692 496.09 325.196 494.109 325.857C493.201 326.187 492.292 326.517 491.302 326.765C489.816 327.26 489.32 328.003 489.32 328.664V338.819C489.32 338.158 489.816 337.415 491.302 336.92C492.292 336.672 493.201 336.342 494.109 336.012C496.09 335.351 497.906 335.846 498.814 336.342L500.218 337.167V327.013L498.814 326.187Z",
    fill: "#CACACB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M461.498 327.178C461.251 327.013 460.92 326.93 460.59 326.765C459.599 326.517 458.691 326.187 457.783 325.857C455.802 325.196 453.985 325.692 453.077 326.187L451.674 327.013V337.167L453.077 336.342C453.985 335.846 455.802 335.351 457.783 336.012C458.691 336.342 459.599 336.672 460.59 336.92C460.92 337.002 461.251 337.167 461.498 337.332C462.324 337.828 462.572 338.323 462.572 338.901V328.746C462.572 328.169 462.241 327.591 461.498 327.178Z",
    fill: "#CACACB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M489.98 330.398V340.552L481.807 341.791L481.889 331.719L489.98 330.398Z",
    fill: "#BDBDBD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M481.312 330.563C481.147 330.233 480.817 329.82 480.239 329.49C479.579 329.159 478.753 328.829 477.515 328.912C476.442 328.912 475.368 328.912 474.295 328.912C471.983 328.912 470.828 329.82 470.497 330.563L470.002 331.719V341.873L470.497 340.717C470.828 339.974 471.983 339.066 474.295 339.066C475.368 339.066 476.442 339.066 477.515 339.066C478.753 339.066 479.661 339.314 480.239 339.644C480.817 339.974 481.147 340.387 481.312 340.717L481.808 341.873V331.719L481.312 330.563Z",
    fill: "#CACACB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M504.757 322.72L506.16 323.545L500.216 327.013L498.813 326.187C497.905 325.692 496.088 325.196 494.107 325.857C493.199 326.187 492.291 326.517 491.3 326.765C489.319 327.426 489.154 328.581 489.484 329.324L489.979 330.48L481.888 331.719L481.393 330.563C481.228 330.233 480.898 329.82 480.32 329.489C479.659 329.159 478.834 328.829 477.595 328.912C476.522 328.912 475.449 328.912 474.376 328.912C472.064 328.912 470.908 329.82 470.578 330.563L470.083 331.719L461.992 330.48L462.487 329.324C462.735 328.746 462.735 327.838 461.579 327.178C461.331 327.013 461.001 326.93 460.671 326.765C459.68 326.517 458.772 326.187 457.864 325.857C455.883 325.196 454.066 325.692 453.158 326.187L451.755 327.013L445.81 323.545L447.214 322.72C448.122 322.224 448.948 321.151 447.792 319.995C447.214 319.5 446.636 318.922 446.141 318.344C445.976 318.096 445.728 317.931 445.48 317.849C444.324 317.188 442.838 317.188 441.765 317.353L439.866 317.684L437.637 312.978L439.536 312.648C440.774 312.483 442.426 311.822 442.426 310.419C442.343 309.758 442.343 309.18 442.426 308.52C442.426 307.777 441.93 307.281 441.352 306.951C440.774 306.621 440.114 306.456 439.536 306.373L437.555 306.043L439.701 301.337L441.683 301.667C442.921 301.833 444.902 301.75 446.058 300.594C446.554 300.016 447.049 299.521 447.709 298.943C448.865 297.787 448.04 296.714 447.131 296.219L445.728 295.393L451.672 291.926L453.076 292.751C453.984 293.246 455.8 293.742 457.781 293.081C458.69 292.751 459.598 292.421 460.588 292.173C462.57 291.513 462.735 290.357 462.405 289.614L461.909 288.458L470 287.22L470.495 288.376C470.661 288.706 470.991 289.119 471.569 289.449C472.229 289.779 473.055 290.109 474.293 290.027C475.366 290.027 476.44 290.027 477.513 290.027C479.824 290.027 480.98 289.119 481.31 288.376L481.806 287.22L489.897 288.458L489.401 289.614C489.154 290.192 489.154 291.1 490.309 291.76C490.557 291.926 490.887 292.008 491.217 292.173C492.208 292.421 493.116 292.751 494.024 293.081C496.006 293.742 497.822 293.246 498.73 292.751L500.134 291.926L506.078 295.393L504.674 296.219C503.766 296.714 502.941 297.787 504.097 298.943C504.674 299.438 505.252 300.016 505.748 300.594C505.913 300.842 506.161 301.007 506.408 301.09C507.564 301.75 509.05 301.75 510.123 301.585L512.022 301.255L514.251 305.96L512.27 306.291C511.031 306.456 509.38 307.116 509.38 308.52C509.463 309.18 509.463 309.758 509.38 310.419C509.38 311.162 509.793 311.657 510.453 311.987C511.031 312.317 511.692 312.483 512.27 312.565L514.169 312.895L512.022 317.601L510.041 317.271C508.802 317.106 506.821 317.188 505.665 318.344C505.17 318.922 504.674 319.417 504.014 319.995C502.941 321.151 503.849 322.224 504.757 322.72ZM464.964 315.702C470.991 319.17 480.65 319.17 486.677 315.702C492.621 312.235 492.621 306.621 486.594 303.153C480.567 299.686 470.908 299.686 464.881 303.153C458.937 306.621 458.937 312.235 464.964 315.702Z",
    fill: "#F1ECEC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M470.001 331.719V341.791L461.828 340.552L461.911 330.398L470.001 331.719Z",
    fill: "#BDBDBD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M504.675 300.099H475.697V318.262H504.675V300.099Z",
    fill: "url(#paint5_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M491.052 317.188C482.631 322.059 469.009 322.059 460.506 317.188C456.46 314.877 454.396 311.822 454.149 308.85C453.901 312.235 455.965 315.702 460.506 318.262C468.927 323.133 482.631 323.133 491.052 318.262C495.428 315.702 497.574 312.317 497.327 308.933C497.079 311.987 495.015 314.959 491.052 317.188Z",
    fill: "#CACACB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M486.513 301.667C480.569 298.2 470.91 298.2 464.965 301.667C459.682 304.722 457.948 310.088 463.314 314.546C463.81 314.134 464.387 313.721 464.965 313.391C470.91 309.923 480.569 309.923 486.513 313.391C487.173 313.803 487.751 314.134 488.247 314.629C493.283 310.171 491.797 304.722 486.513 301.667Z",
    fill: "url(#paint6_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M490.971 299.521C482.55 294.65 468.845 294.65 460.425 299.521C456.049 302.08 453.902 305.465 454.15 308.85C454.398 311.905 456.462 314.877 460.507 317.188C468.928 322.059 482.633 322.059 491.054 317.188C495.016 314.877 497.08 311.987 497.328 308.933C497.576 305.548 495.429 302.163 490.971 299.521ZM464.965 302.163C470.909 298.695 480.569 298.695 486.513 302.163C489.733 304.062 491.219 306.538 490.971 308.933C490.723 310.996 489.32 313.06 486.595 314.629C480.651 318.096 470.992 318.096 465.048 314.629C462.323 313.06 460.837 310.996 460.59 308.933C460.259 306.456 461.745 303.979 464.965 302.163Z",
    fill: "#59595B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M497.329 309.015C497.577 305.63 495.513 302.163 490.972 299.604C490.725 299.438 490.395 299.273 490.064 299.108H475.699V299.604C479.579 299.604 483.542 300.429 486.514 302.163C489.734 304.062 491.22 306.538 490.972 308.933C490.725 310.997 489.321 313.06 486.597 314.629C483.625 316.363 479.662 317.188 475.699 317.188H491.055C495.018 314.959 497.082 311.987 497.329 309.015Z",
    fill: "#59595B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M465.297 293.659C470.993 290.357 480.322 290.357 486.102 293.659C489.239 295.476 490.642 297.87 490.395 300.264C490.147 302.245 488.743 304.227 486.184 305.713C480.488 309.015 471.159 309.015 465.379 305.713C462.738 304.144 461.252 302.163 461.086 300.181C460.839 297.87 462.242 295.476 465.297 293.659Z",
    fill: "url(#paint7_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M489.651 296.962C490.311 298.035 490.559 299.191 490.394 300.264C490.146 302.245 488.743 304.227 486.183 305.713C480.487 309.015 471.158 309.015 465.379 305.713C462.737 304.144 461.251 302.163 461.086 300.181C461.003 299.026 461.251 297.952 461.829 296.879C460.838 298.2 460.343 299.603 460.508 301.007C460.756 303.071 462.242 305.135 464.966 306.703C470.91 310.171 480.569 310.171 486.514 306.703C489.238 305.135 490.724 303.071 490.889 301.007C491.137 299.686 490.642 298.283 489.651 296.962Z",
    fill: "url(#paint8_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M490.973 300.346C490.973 300.594 490.973 300.842 490.973 301.089C490.726 303.153 489.322 305.217 486.598 306.786C480.653 310.253 470.994 310.253 465.05 306.786C462.325 305.217 460.839 303.153 460.592 301.089C460.592 300.842 460.592 300.677 460.592 300.429V308.52C460.592 308.685 460.592 308.85 460.592 308.932C460.839 310.996 462.325 313.06 465.05 314.629C470.994 318.096 480.653 318.096 486.598 314.629C489.322 313.06 490.808 310.996 490.973 308.932C490.973 308.767 490.973 308.602 490.973 308.437V300.346Z",
    fill: "#C0162E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M100.719 255.683C101.132 255.27 101.628 254.939 102.123 254.774H108.397L111.039 248.995L108.645 248.665C107.902 248.583 107.076 248.335 106.416 247.922C105.673 247.509 105.095 246.849 105.095 245.941C105.178 245.198 105.178 244.372 105.095 243.629C105.012 241.978 107.076 241.152 108.562 240.905L110.957 240.574L108.232 234.795H101.958C101.793 234.713 101.545 234.63 101.38 234.548C101.05 234.383 100.802 234.135 100.554 233.887C99.9764 233.227 99.3159 232.566 98.5729 231.906C97.0868 230.502 98.1601 229.181 99.2333 228.603L100.967 227.613L93.702 223.402L91.9682 224.393C90.8124 225.053 88.6659 225.631 86.1892 224.806C85.0334 224.393 83.9601 223.98 82.7217 223.65C82.3089 223.485 81.8961 223.32 81.5659 223.155C80.1624 222.329 80.0799 221.256 80.4101 220.513L81.0706 219.109L71.1636 217.541L70.5031 218.944C70.0903 219.852 68.6868 221.008 65.8799 221.008C64.5589 221.008 63.238 221.008 61.9171 221.008C60.431 221.008 59.2752 220.678 58.5322 220.265C57.8717 219.852 57.4589 219.439 57.2938 219.027L56.6334 217.623L46.7264 219.192L47.3869 220.595C47.7996 221.503 47.6345 222.907 45.1578 223.733C44.002 224.063 42.8462 224.476 41.7729 224.888C39.3787 225.714 37.1496 225.136 35.9938 224.476L34.2601 223.485L26.995 227.695L28.7287 228.686C29.8845 229.346 30.8752 230.585 29.4717 231.988C28.7287 232.649 28.0683 233.309 27.4903 233.97C26.0869 235.373 23.6927 235.538 22.1241 235.291L19.7299 234.96L17.088 240.739L19.4822 241.07C20.2252 241.152 21.0508 241.4 21.7113 241.813C22.4543 242.226 23.0322 242.886 23.0322 243.794C22.9496 244.537 22.9496 245.363 23.0322 246.106C23.0322 246.684 22.7845 247.179 22.3717 247.592H6.35547V254.939H20.0601H26.3345C26.4996 255.022 26.7473 255.105 26.9124 255.187C27.2427 255.352 27.4903 255.6 27.738 255.848C28.3159 256.508 28.9764 257.169 29.7194 257.829C29.9671 258.077 30.2148 258.324 30.2973 258.655H20.8857V266.415H35.0857V266.085L36.2415 265.424C37.3973 264.764 39.5438 264.186 42.0206 265.012C42.4334 265.177 42.9287 265.342 43.3415 265.507V272.194H56.9636H57.0462L57.7066 270.791C57.7892 270.708 57.7892 270.626 57.8717 270.46V272.112H71.5764L81.4834 270.543L80.8229 269.139C80.4927 268.314 80.5752 267.158 82.3915 266.333H94.0322L101.297 262.122L99.5636 261.131C98.4078 260.471 97.4171 259.232 98.8206 257.829C99.481 257.003 100.141 256.343 100.719 255.683ZM77.3554 252.463C70.0903 256.673 58.202 256.673 50.8543 252.463C43.5066 248.252 43.5066 241.317 50.7717 237.107C58.0368 232.896 69.9252 232.896 77.2729 237.107C84.6206 241.317 84.7031 248.17 77.3554 252.463Z",
    fill: "url(#paint9_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1653 210.139C74.0743 210.319 73.9829 210.588 73.9819 210.768L73.9215 221.838C73.923 221.568 74.0139 221.388 74.1049 221.209L74.6517 219.952L74.7121 208.882L74.1653 210.139Z",
    fill: "#BDBDBD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6483 209.978L44.1152 208.715L44.0548 219.785L44.5879 221.048C44.6769 221.228 44.7655 221.499 44.764 221.769L44.8244 210.699C44.8259 210.429 44.7373 210.159 44.6483 209.978Z",
    fill: "#BDBDBD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8664 217.43C90.2344 217.787 89.601 218.413 89.5971 219.133L89.5367 230.203C89.5406 229.483 90.174 228.856 90.806 228.5L92.3408 227.608L92.4012 216.539L90.8664 217.43Z",
    fill: "#BDBDBD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9586 217.086L26.4336 216.178L26.3732 227.248L27.8982 228.156C28.5262 228.519 29.1528 229.153 29.1488 229.873L29.2092 218.803C29.3032 218.084 28.6766 217.45 27.9586 217.086Z",
    fill: "#BDBDBD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0873 228.455C97.7364 228.627 96.0226 229.338 95.9247 230.777L95.8643 241.847C95.8722 240.407 97.676 239.697 99.0269 239.524L101.189 239.176L101.249 228.106L99.0873 228.455Z",
    fill: "#BDBDBD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8379 232.269L22.8477 230.469C22.8522 229.659 22.3151 229.116 21.6871 228.752C21.0591 228.389 20.3401 228.205 19.7107 228.112L17.5527 227.74L17.4923 238.809L19.6503 239.181C20.2798 239.274 20.9987 239.458 21.6267 239.822C22.1647 240.185 22.6123 240.637 22.7888 241.268L22.7819 242.528C22.78 242.888 22.778 243.248 22.776 243.608L22.8364 232.539C22.8369 232.449 22.8374 232.359 22.8379 232.269Z",
    fill: "#BDBDBD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.207 235.666L101.147 246.736L98.7788 251.853L98.8392 240.783L101.207 235.666Z",
    fill: "#BDBDBD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0014 240.353L19.8511 251.422L17.5392 246.279L17.5996 235.21L20.0014 240.353Z",
    fill: "#BDBDBD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7695 240.412C95.4206 240.224 93.2602 240.302 91.9934 241.555C91.45 242.182 90.907 242.72 90.1836 243.346C89.7312 243.793 89.5488 244.242 89.5468 244.602L89.4865 255.671C89.4884 255.311 89.6708 254.862 90.1233 254.415C90.7562 253.878 91.3896 253.252 91.933 252.625C93.1998 251.372 95.3602 251.294 96.7091 251.481L98.867 251.853L98.9274 240.783L96.7695 240.412Z",
    fill: "#CACACB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6272 243.01C28.0002 242.466 27.3737 241.833 26.8371 241.2C26.6586 240.929 26.3896 240.748 26.1201 240.656C24.8641 239.929 23.2442 239.921 22.0733 240.094L20.0014 240.443L19.941 251.512L22.0129 251.164C23.0938 250.99 24.8037 250.999 26.0597 251.726C26.3287 251.907 26.5977 252.089 26.7767 252.27C27.3133 252.902 27.9403 253.446 28.5668 254.079C29.0143 254.532 29.1919 254.983 29.1899 255.343L29.2503 244.273C29.2523 243.913 29.0747 243.462 28.6272 243.01Z",
    fill: "#CACACB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4132 247.228L92.3528 258.297L85.8531 261.952L85.913 250.972L92.4132 247.228Z",
    fill: "#BDBDBD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9063 250.683L32.8464 261.663L26.3869 257.937L26.4473 246.868L32.9063 250.683Z",
    fill: "#BDBDBD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3885 250.064C83.4015 249.518 81.4246 248.968 79.2608 249.676C78.2689 250.03 77.2769 250.385 76.1955 250.649C74.5727 251.18 74.0283 251.987 74.0244 252.707L73.964 263.777C73.9679 263.057 74.5123 262.25 76.1351 261.719C77.2165 261.454 78.2085 261.1 79.2004 260.745C81.3642 260.037 83.3411 260.588 84.3281 261.133L85.8532 262.042L85.9136 250.972L84.3885 250.064Z",
    fill: "#CACACB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7036 250.922C43.4346 250.74 43.0751 250.648 42.7161 250.467C41.6377 250.191 40.6496 249.825 39.6617 249.46C37.5057 248.728 35.5229 249.257 34.53 249.792L32.9951 250.683L32.9347 261.753L34.4696 260.861C35.4625 260.327 37.4453 259.798 39.6013 260.529C40.5893 260.895 41.5773 261.26 42.6557 261.536C43.0152 261.628 43.3742 261.81 43.6432 261.991C44.5402 262.536 44.8072 263.078 44.8038 263.708L44.8642 252.638C44.8676 252.008 44.5111 251.376 43.7036 250.922Z",
    fill: "#CACACB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7338 254.601L74.6734 265.67L65.7565 266.972L65.9064 255.993L74.7338 254.601Z",
    fill: "#BDBDBD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2823 254.729C65.1043 254.368 64.7468 253.917 64.1188 253.553C63.4008 253.189 62.5028 252.824 61.1524 252.907C59.9825 252.901 58.8125 252.894 57.6426 252.888C55.1227 252.874 53.8574 253.857 53.493 254.665L52.9461 255.922L52.8857 266.991L53.4326 265.735C53.797 264.927 55.0623 263.943 57.5822 263.957C58.7521 263.964 59.9221 263.97 61.092 263.976C62.4419 263.984 63.4304 264.259 64.0584 264.622C64.6864 264.986 65.0439 265.438 65.2219 265.799L65.755 267.062L65.8154 255.992L65.2823 254.729Z",
    fill: "#CACACB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8886 246.319L92.4136 247.228L85.9133 250.972L84.3883 250.064C83.4013 249.519 81.4244 248.968 79.2606 249.676C78.2686 250.031 77.2767 250.385 76.1953 250.649C74.0315 251.357 73.8447 252.616 74.2002 253.428L74.7333 254.691L65.9064 255.993L65.3733 254.73C65.1953 254.369 64.8378 253.917 64.2098 253.554C63.4918 253.19 62.5938 252.825 61.2434 252.908C60.0734 252.901 58.9035 252.895 57.7336 252.888C55.2137 252.875 53.9484 253.858 53.584 254.666L53.0372 255.923L44.225 254.525L44.7718 253.268C45.0453 252.639 45.0506 251.649 43.7946 250.922C43.5256 250.741 43.1662 250.649 42.8072 250.467C41.7287 250.191 40.7407 249.826 39.7527 249.46C37.5968 248.729 35.614 249.258 34.6211 249.792L33.0862 250.684L26.6272 246.869L28.162 245.977C29.1549 245.443 30.0613 244.278 28.8082 243.011C28.1812 242.467 27.5547 241.834 27.0181 241.201C26.8396 240.93 26.5706 240.749 26.3011 240.657C25.0451 239.93 23.4252 239.922 22.2543 240.095L20.1824 240.444L17.7805 235.301L19.8524 234.952C21.2033 234.78 23.0072 234.069 23.0155 232.54C22.9294 231.819 22.9329 231.189 23.0268 230.47C23.0312 229.66 22.4941 229.117 21.8661 228.753C21.2381 228.39 20.5192 228.206 19.8897 228.113L17.7318 227.741L20.0996 222.624L22.2576 222.996C23.6065 223.183 25.7669 223.105 27.0337 221.852C27.5771 221.225 28.12 220.688 28.8434 220.062C30.1102 218.809 29.2166 217.634 28.2296 217.088L26.7047 216.18L33.2049 212.436L34.7299 213.344C35.7169 213.889 37.6939 214.44 39.8577 213.732C40.8496 213.377 41.8415 213.023 42.9229 212.759C45.0867 212.05 45.2736 210.791 44.918 209.98L44.3849 208.717L53.2118 207.415L53.7449 208.678C53.9229 209.039 54.2805 209.491 54.9085 209.854C55.6265 210.218 56.5244 210.583 57.8748 210.5C59.0448 210.507 60.2147 210.513 61.3847 210.519C63.9045 210.533 65.1698 209.55 65.5342 208.742L66.0811 207.485L74.8933 208.883L74.3464 210.14C74.073 210.769 74.0676 211.759 75.3236 212.485C75.5926 212.667 75.9521 212.759 76.3111 212.941C77.3895 213.217 78.3775 213.582 79.3655 213.947C81.5215 214.679 83.5043 214.15 84.4972 213.615L86.032 212.724L92.491 216.539L90.9562 217.431C89.9633 217.965 89.0569 219.13 90.31 220.397C90.937 220.94 91.5636 221.574 92.1001 222.207C92.2786 222.478 92.5476 222.659 92.8171 222.751C94.0731 223.477 95.6931 223.486 96.864 223.313L98.9358 222.964L101.338 228.107L99.1758 228.455C97.8249 228.628 96.0211 229.338 96.0128 230.868C96.0988 231.588 96.0954 232.218 96.0015 232.938C95.997 233.748 96.4441 234.29 97.162 234.654C97.7901 235.017 98.509 235.201 99.1385 235.295L101.206 235.666L98.8386 240.783L96.6806 240.411C95.3317 240.224 93.1714 240.302 91.9045 241.555C91.3611 242.182 90.8182 242.719 90.0948 243.345C88.918 244.599 89.9016 245.774 90.8886 246.319ZM47.5527 238.433C54.1017 242.249 64.6311 242.306 71.2214 238.562C77.7217 234.818 77.7551 228.698 71.2061 224.883C64.657 221.067 54.1276 221.01 47.5373 224.754C41.0371 228.498 41.0037 234.618 47.5527 238.433Z",
    fill: "#F1ECEC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9465 255.922L52.8866 266.902L43.9845 265.503L44.1349 254.434L52.9465 255.922Z",
    fill: "#BDBDBD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9831 240.208C66.7746 245.468 51.9254 245.387 42.6849 240.027C38.2889 237.483 36.0572 234.141 35.8049 230.899C35.5148 234.588 37.744 238.38 42.6785 241.197C51.829 246.556 66.7682 246.638 75.9767 241.378C80.7616 238.614 83.1217 234.937 82.8718 231.246C82.5837 234.574 80.3161 237.802 75.9831 240.208Z",
    fill: "#CACACB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1258 223.262C64.6667 219.447 54.1374 219.39 47.6371 223.134C41.8592 226.433 39.9374 232.272 45.7606 237.164C46.303 236.717 46.9354 236.27 47.5674 235.914C54.0676 232.169 64.597 232.227 71.056 236.042C71.7735 236.496 72.4016 236.859 72.9386 237.402C78.4548 232.572 76.8673 226.624 71.1258 223.262Z",
    fill: "#F1ECEC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9964 220.949C66.8459 215.589 51.9067 215.507 42.6983 220.767C37.9133 223.531 35.5533 227.208 35.8031 230.899C36.055 234.23 38.2872 237.483 42.6832 240.026C51.8337 245.386 66.7729 245.468 75.9813 240.208C80.3148 237.712 82.5819 234.574 82.8701 231.246C83.1602 227.558 80.8405 223.855 75.9964 220.949ZM47.6323 223.674C54.1326 219.929 64.662 219.987 71.121 223.802C74.6195 225.891 76.2247 228.6 75.9405 231.208C75.6582 233.457 74.116 235.698 71.1369 237.392C64.6366 241.136 54.1071 241.079 47.6481 237.264C44.6876 235.538 43.08 233.279 42.8223 231.027C42.4771 228.326 44.1117 225.635 47.6323 223.674Z",
    fill: "#59595B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M411.222 296.714C411.222 300.099 408.828 301.502 405.856 299.768L226.87 196.406C223.898 194.672 221.504 190.544 221.504 187.159V52.1766C221.504 48.7918 223.898 47.3883 226.87 49.122L405.939 152.485C408.911 154.218 411.305 158.346 411.305 161.731V296.714H411.222Z",
    fill: "#313131"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M409.902 150.091L230.916 46.7279C229.43 45.9023 228.109 45.8197 227.118 46.3976L223.32 48.6267C224.228 48.1314 225.549 48.2965 226.953 49.0395L406.021 152.402C408.993 154.136 411.388 158.264 411.388 161.649V296.714C411.388 298.365 410.81 299.603 409.819 300.181L413.617 297.952C414.69 297.457 415.35 296.218 415.35 294.402V159.337C415.268 155.952 412.874 151.824 409.902 150.091Z",
    fill: "#292929"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M405.94 291.513L226.871 188.15V55.2313L405.94 158.594V291.513Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M284.495 372.254C281.606 373.988 276.735 373.988 273.845 372.254L94.7765 268.892C91.887 267.241 91.887 264.434 94.7765 262.7L216.797 192.278C219.687 190.627 224.558 190.627 227.447 192.278L406.516 295.641C409.488 297.292 409.488 300.099 406.516 301.832L284.495 372.254Z",
    fill: "url(#paint10_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M227.696 206.891L218.945 201.855L223.321 199.295L232.072 204.414L227.696 206.891Z",
    fill: "#59595B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M242.392 215.394L233.641 210.358L238.016 207.799L246.767 212.917L242.392 215.394Z",
    fill: "#59595B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M257.169 223.898L248.418 218.862L252.794 216.385L261.545 221.421L257.169 223.898Z",
    fill: "#59595B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M271.946 232.484L263.195 227.365L267.571 224.888L276.322 229.924L271.946 232.484Z",
    fill: "#59595B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M286.644 240.987L277.893 235.869L282.268 233.392L291.019 238.428L286.644 240.987Z",
    fill: "#59595B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M301.421 249.491L292.67 244.455L297.045 241.895L305.797 246.931L301.421 249.491Z",
    fill: "#59595B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M316.198 257.994L307.447 252.958L311.823 250.399L320.574 255.435L316.198 257.994Z",
    fill: "#59595B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M330.894 266.498L322.143 261.462L326.518 258.902L335.269 264.021L330.894 266.498Z",
    fill: "#59595B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M345.673 275.001L336.922 269.965L341.297 267.406L350.049 272.524L345.673 275.001Z",
    fill: "#59595B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M360.449 283.505L351.615 278.469L356.073 275.992L364.825 281.028L360.449 283.505Z",
    fill: "#59595B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M375.146 292.091L366.395 286.972L370.77 284.495L379.521 289.531L375.146 292.091Z",
    fill: "#59595B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M389.923 300.594L381.172 295.476L385.547 292.999L394.299 298.035L389.923 300.594Z",
    fill: "#59595B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M219.937 219.439L204.168 210.358L212.919 205.322L228.688 214.403L219.937 219.439Z",
    fill: "#59595B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M211.764 231.08L190.051 218.531L198.802 213.495L220.515 226.044L211.764 231.08Z",
    fill: "#59595B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M203.011 243.051L175.271 227.035L184.023 221.999L211.762 238.015L203.011 243.051Z",
    fill: "#59595B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M173.208 246.436L157.439 237.355L169.328 230.502L185.014 239.584L173.208 246.436Z",
    fill: "#59595B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M194.921 258.985L179.152 249.903L191.041 243.051L206.809 252.133L194.921 258.985Z",
    fill: "#59595B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M216.633 271.534L200.947 262.452L212.753 255.6L228.522 264.681L216.633 271.534Z",
    fill: "#59595B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M291.597 314.794L275.828 305.713L287.716 298.86L303.485 307.942L291.597 314.794Z",
    fill: "#59595B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M328.416 336.094L297.539 318.262L309.427 311.409L340.304 329.242L328.416 336.094Z",
    fill: "#59595B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M269.883 302.245L222.66 275.001L234.466 268.149L281.772 295.393L269.883 302.245Z",
    fill: "#59595B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M238.76 230.337L225.881 222.907L234.632 217.871L247.511 225.301L238.76 230.337Z",
    fill: "#59595B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M230.668 241.978L217.789 234.548L226.54 229.512L239.419 236.942L230.668 241.978Z",
    fill: "#59595B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M222.331 253.701L209.369 246.271L218.203 241.235L231.082 248.665L222.331 253.701Z",
    fill: "#59595B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M241.154 264.599L228.275 257.168L237.027 252.132L249.906 259.563L241.154 264.599Z",
    fill: "#59595B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M260.059 275.496L247.18 268.066L255.931 263.03L268.81 270.46L260.059 275.496Z",
    fill: "#59595B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M278.883 286.394L266.004 278.964L274.755 273.928L287.634 281.358L278.883 286.394Z",
    fill: "#59595B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M297.789 297.292L284.91 289.861L293.661 284.825L306.54 292.256L297.789 297.292Z",
    fill: "#59595B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M316.695 308.189L303.816 300.759L312.568 295.723L325.447 303.153L316.695 308.189Z",
    fill: "#59595B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M346.663 325.527L322.639 311.657L331.39 306.621L355.414 320.491L346.663 325.527Z",
    fill: "#59595B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M249.492 252.876L236.613 245.445L245.364 240.409L258.243 247.84L249.492 252.876Z",
    fill: "#59595B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M268.399 263.773L255.52 256.343L264.271 251.307L277.15 258.737L268.399 263.773Z",
    fill: "#59595B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M287.303 274.671L274.424 267.241L283.175 262.205L296.054 269.635L287.303 274.671Z",
    fill: "#59595B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M306.127 285.569L293.248 278.138L301.999 273.102L314.878 280.533L306.127 285.569Z",
    fill: "#59595B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M325.033 296.466L312.154 289.036L320.905 284L333.785 291.43L325.033 296.466Z",
    fill: "#59595B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 317.271L330.977 299.934L339.81 294.898L369.779 312.152L361.028 317.271Z",
    fill: "#59595B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M257.666 241.235L244.787 233.805L253.538 228.769L266.417 236.199L257.666 241.235Z",
    fill: "#59595B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M276.57 252.133L263.691 244.702L272.443 239.666L285.322 247.096L276.57 252.133Z",
    fill: "#59595B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M295.395 263.03L282.516 255.6L291.267 250.564L304.146 257.994L295.395 263.03Z",
    fill: "#59595B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M314.301 273.928L301.422 266.498L310.173 261.462L323.052 268.892L314.301 273.928Z",
    fill: "#59595B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M333.206 284.826L320.244 277.395L329.078 272.359L341.957 279.789L333.206 284.826Z",
    fill: "#59595B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M352.029 295.723L339.15 288.293L347.902 283.257L360.781 290.687L352.029 295.723Z",
    fill: "#59595B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M375.146 309.098L358.057 299.191L366.808 294.155L383.897 304.062L375.146 309.098Z",
    fill: "#59595B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M383.483 287.22L242.061 205.57L246.271 203.093L387.776 284.743L383.483 287.22Z",
    fill: "#292929"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M269.884 312.813L197.728 271.121L152.816 297.044L225.055 338.736L269.884 312.813Z",
    fill: "#59595B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M406.517 301.75L284.496 372.172C282.185 373.493 278.635 373.823 275.828 372.997C275.828 372.997 274.094 372.337 273.846 372.172L94.7779 268.892C94.6128 268.809 94.3651 268.644 94.2 268.561C94.1174 268.561 94.1174 268.479 94.0349 268.479C93.9523 268.396 93.8698 268.314 93.7046 268.231C93.6221 268.149 93.6221 268.149 93.5395 268.066C93.457 267.984 93.2919 267.818 93.2093 267.736C93.2093 267.736 93.2093 267.736 93.2093 267.653C93.1267 267.488 93.0442 267.406 92.9616 267.24C92.7139 266.828 92.5488 266.415 92.5488 265.92V268.479C92.5488 269.635 93.2093 270.708 94.6953 271.616L273.764 374.979C278.057 377.125 284.166 376.713 285.982 376.3C287.799 375.887 289.45 375.474 291.349 375.061L406.517 308.602C408.003 307.777 408.746 306.621 408.746 305.465V298.778C408.746 299.851 408.003 300.924 406.517 301.75Z",
    fill: "#292929"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M367.136 207.303C358.632 203.01 357.146 184.104 348.312 179.729C339.974 175.601 333.617 207.303 325.114 202.35C316.94 197.644 317.023 174.858 308.684 170.07C302.41 166.437 301.584 176.839 295.31 173.207C287.467 168.666 284.66 135.56 277.725 131.515C271.121 127.717 270.047 139.523 265.507 136.881C259.067 133.166 262.7 111.206 254.196 106.335C245.445 101.381 246.436 122.434 241.978 119.709C237.437 116.985 237.519 106.252 230.502 107.408C230.502 109.637 230.502 177.995 230.502 177.995L402.305 277.23V189.553C393.224 184.6 375.639 211.596 367.136 207.303Z",
    fill: "url(#paint11_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M286.311 210.11L288.457 211.266V157.851L286.311 156.695V210.11Z",
    fill: "#59595B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M290.438 158.842C290.438 156.943 289.117 154.714 287.466 153.723C285.815 152.815 284.494 153.558 284.494 155.457C284.494 157.356 285.815 159.585 287.466 160.575C289.117 161.484 290.438 160.741 290.438 158.842Z",
    fill: "#292929"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M366.061 255.93L368.207 257.086V207.881L366.061 206.643V255.93Z",
    fill: "#C0162E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M370.108 208.624C370.108 206.725 368.787 204.496 367.136 203.506C365.485 202.597 364.164 203.34 364.164 205.239C364.164 207.138 365.485 209.367 367.136 210.358C368.787 211.184 370.108 210.44 370.108 208.624Z",
    fill: "#59595B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M235.622 185.921L231.576 183.609V181.958L235.622 184.27V185.921Z",
    fill: "#292929"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M242.473 189.884L238.428 187.489V185.921L242.473 188.232V189.884Z",
    fill: "#292929"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M249.325 193.764L245.279 191.452V189.884L249.325 192.195V193.764Z",
    fill: "#292929"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M256.096 197.727L252.133 195.415V193.764L256.096 196.158V197.727Z",
    fill: "#292929"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M262.948 201.689L258.902 199.378V197.727L262.948 200.038V201.689Z",
    fill: "#292929"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M269.801 205.652L265.756 203.341V201.689L269.801 204.001V205.652Z",
    fill: "#292929"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M276.651 209.615L272.605 207.221V205.652L276.651 207.964V209.615Z",
    fill: "#292929"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M283.504 213.495L279.459 211.184V209.615L283.504 211.927V213.495Z",
    fill: "#292929"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M290.274 217.458L286.229 215.146V213.495L290.274 215.889V217.458Z",
    fill: "#292929"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M297.127 221.421L293.082 219.109V217.458L297.127 219.77V221.421Z",
    fill: "#292929"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M303.979 225.384L299.934 223.072V221.421L303.979 223.732V225.384Z",
    fill: "#292929"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M310.83 229.346L306.785 226.952V225.384L310.83 227.695V229.346Z",
    fill: "#292929"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M317.601 233.227L313.639 230.915V229.346L317.601 231.658V233.227Z",
    fill: "#292929"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M324.454 237.189L320.408 234.878V233.227L324.454 235.621V237.189Z",
    fill: "#292929"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M331.305 241.152L327.26 238.841V237.189L331.305 239.501V241.152Z",
    fill: "#292929"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M338.157 245.115L334.111 242.803V241.152L338.157 243.464V245.115Z",
    fill: "#292929"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M345.01 249.078L340.965 246.684V245.115L345.01 247.427V249.078Z",
    fill: "#292929"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M351.78 252.958L347.734 250.646V249.078L351.78 251.389V252.958Z",
    fill: "#292929"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M358.633 256.921L354.588 254.609V252.958L358.633 255.352V256.921Z",
    fill: "#292929"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M365.485 260.884L361.439 258.572V256.921L365.485 259.232V260.884Z",
    fill: "#292929"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M372.336 264.846L368.291 262.452V260.884L372.336 263.195V264.846Z",
    fill: "#292929"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M379.107 268.727L375.145 266.415V264.846L379.107 267.158V268.727Z",
    fill: "#292929"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M385.959 272.689L381.914 270.378V268.727L385.959 271.121V272.689Z",
    fill: "#292929"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M392.811 276.652L388.766 274.341V272.689L392.811 275.001V276.652Z",
    fill: "#292929"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M399.663 280.615L395.617 278.303V276.652L399.663 278.964V280.615Z",
    fill: "#292929"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M274.422 110.793L221.502 80.2466V189.306L264.845 214.321L259.479 220.348H276.321C277.724 220.348 278.715 219.274 278.715 217.293V118.223C278.715 115.499 276.816 112.197 274.422 110.793Z",
    fill: "url(#paint12_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M261.626 217.293C261.626 220.017 259.727 221.091 257.333 219.77L139.027 151.494C136.633 150.173 134.734 146.788 134.734 144.064V44.9943C134.734 42.2698 136.633 41.1966 139.027 42.5175L257.333 110.793C259.727 112.114 261.626 115.499 261.626 118.223V217.293Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M257.333 110.793L139.027 42.5175C136.633 41.1966 134.734 42.2698 134.734 44.9943V49.7826L261.626 123.012V118.306C261.626 115.499 259.645 112.197 257.333 110.793Z",
    fill: "#C0162E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M139.111 45.4896L142.496 47.471V51.3513L139.111 49.3699V45.4896Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M145.715 49.2872L149.1 51.2686V55.1489L145.715 53.1675V49.2872Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M152.32 53.085L155.705 55.0664V58.9466L152.32 57.0477V53.085Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M160.493 152.32L159.75 151.907V85.1176L160.493 85.5303V152.32Z",
    fill: "#292929"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M209.45 180.555L208.707 180.142V139.193L209.45 139.606V180.555Z",
    fill: "#292929"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M208.129 149.678C203.258 146.871 200.946 142.743 198.47 138.367C195.415 132.919 191.865 126.727 182.288 121.195C175.271 117.15 172.711 111.123 170.317 105.427C168.088 100.143 166.024 95.107 160.163 91.7221C154.218 88.2547 152.072 93.043 149.76 97.9965C147.531 102.785 145.302 107.821 139.275 104.354V102.702C144.311 105.592 146.375 101.299 148.439 96.6756C150.668 91.7221 153.228 86.1907 160.163 90.1535C166.767 93.9512 169.161 99.7303 171.473 105.262C173.785 110.793 176.014 115.994 182.206 119.627C192.443 125.488 196.323 132.341 199.46 137.872C201.937 142.248 203.836 145.633 208.211 148.109C215.972 152.485 220.678 147.779 226.044 142.33C232.896 135.313 240.657 127.47 257.086 136.964V138.615C241.4 129.534 233.804 137.212 227.2 143.981C221.834 149.43 216.715 154.631 208.211 149.843C208.211 149.678 208.129 149.678 208.129 149.678Z",
    fill: "#C0162E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M153.145 68.6884V76.9442L158.181 79.8337L160.162 83.2186L162.061 82.0628L167.097 84.9523V76.7791L153.145 68.6884Z",
    fill: "url(#paint13_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M202.102 122.764V130.937L207.138 133.827L209.036 137.294L211.018 136.138L216.054 139.028V130.855L202.102 122.764Z",
    fill: "url(#paint14_linear)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M157.355 75.1279L162.887 78.2651V79.4209L157.355 76.2837V75.1279Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M206.312 128.956L211.844 132.093V133.249L206.312 130.112V128.956Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M146.457 149.43L141.916 146.788V145.302L146.457 147.944V149.43Z",
    fill: "#292929"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M154.795 154.219L150.172 151.577V150.091L154.795 152.733V154.219Z",
    fill: "#292929"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M163.05 159.007L158.51 156.365V154.879L163.05 157.521V159.007Z",
    fill: "#292929"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M171.388 163.795L166.848 161.153V159.667L171.388 162.309V163.795Z",
    fill: "#292929"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M179.644 168.584L175.104 165.942V164.456L179.644 167.098V168.584Z",
    fill: "#292929"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M187.984 173.372L183.443 170.73V169.327L187.984 171.886V173.372Z",
    fill: "#292929"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M196.24 178.16L191.699 175.519V174.115L196.24 176.674V178.16Z",
    fill: "#292929"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M204.578 182.949L200.037 180.307V178.903L204.578 181.463V182.949Z",
    fill: "#292929"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M212.834 187.737L208.293 185.095V183.692L212.834 186.251V187.737Z",
    fill: "#292929"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M221.172 192.526L216.631 189.884V188.48L221.172 191.122V192.526Z",
    fill: "#292929"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M229.51 197.314L224.887 194.672V193.269L229.51 195.91V197.314Z",
    fill: "#292929"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M237.765 202.102L233.225 199.46V198.057L237.765 200.699V202.102Z",
    fill: "#292929"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M246.103 206.891L241.562 204.249V202.845L246.103 205.487V206.891Z",
    fill: "#292929"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M254.359 211.679L249.818 209.037V207.634L254.359 210.276V211.679Z",
    fill: "#292929"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M260.883 108.729L142.577 40.4535C141.421 39.7931 140.348 39.7105 139.605 40.1233L136.055 42.1872C136.798 41.7744 137.871 41.857 139.027 42.5175L257.333 110.793C259.727 112.114 261.626 115.499 261.626 118.223V217.293C261.626 218.614 261.213 219.522 260.47 220.017L263.772 218.119C264.68 217.706 265.176 216.715 265.176 215.229V116.159C265.176 113.435 263.194 110.133 260.883 108.729Z",
    fill: "#292929"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M162.475 152.32V198.635C162.475 200.203 163.548 201.855 165.612 203.01C169.822 205.487 176.675 205.487 180.885 203.01C183.032 201.772 184.022 200.203 184.022 198.635V152.32H162.475Z",
    fill: "#59595B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M165.694 147.862C169.905 145.385 176.757 145.385 180.968 147.862C183.114 149.1 184.105 150.669 184.105 152.32C184.105 153.888 183.032 155.539 180.968 156.695C176.757 159.172 169.905 159.172 165.694 156.695C163.548 155.457 162.557 153.888 162.557 152.32C162.475 150.669 163.548 149.1 165.694 147.862Z",
    fill: "#CACACB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M135.643 185.178V214.156C135.643 215.724 136.716 217.376 138.78 218.531C142.99 221.008 149.843 221.008 154.053 218.531C156.2 217.293 157.19 215.724 157.19 214.156V185.178H135.643Z",
    fill: "#292929"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M138.78 180.72C142.99 178.243 149.843 178.243 154.053 180.72C156.2 181.958 157.19 183.527 157.19 185.178C157.19 186.747 156.117 188.398 154.053 189.554C149.843 192.03 142.99 192.03 138.78 189.554C136.633 188.315 135.643 186.747 135.643 185.178C135.643 183.527 136.716 181.958 138.78 180.72Z",
    fill: "#313131"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M108.729 214.651V229.677C108.729 231.245 109.802 232.897 111.866 234.052C116.076 236.529 122.929 236.529 127.139 234.052C129.285 232.814 130.276 231.245 130.276 229.677V214.651H108.729Z",
    fill: "#C0162E"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M111.946 210.193C116.157 207.716 123.009 207.716 127.22 210.193C129.366 211.431 130.357 213 130.357 214.651C130.357 216.22 129.284 217.871 127.22 219.027C123.009 221.503 116.157 221.503 111.946 219.027C109.8 217.788 108.809 216.22 108.809 214.651C108.727 213.083 109.8 211.431 111.946 210.193Z",
    fill: "url(#paint15_linear)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M436.319 370.191H386.867L403.709 379.932L386.867 389.674H436.319L453.161 379.932L436.319 370.191Z",
    fill: "url(#paint16_linear)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M411.636 382.739H364.99L381.832 392.481L364.99 402.223H411.636L428.477 392.481L411.636 382.739Z",
    fill: "url(#paint17_linear)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M384.722 395.288H343.195L360.037 405.03L343.195 414.772H384.722L401.646 405.03L384.722 395.288Z",
    fill: "url(#paint18_linear)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M458.114 357.724H408.662L425.504 367.384L408.662 377.126H458.114L474.956 367.384L458.114 357.724Z",
    fill: "url(#paint19_linear)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M391.82 320.573L408.662 330.315V377.126L391.82 367.384V320.573Z",
    fill: "#CACACB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M425.504 320.573L408.662 330.315V377.126L425.504 367.384V320.573Z",
    fill: "#F1ECEC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M408.662 310.831L391.82 320.573L408.662 330.315L425.504 320.573L408.662 310.831Z",
    fill: "#F1ECEC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M391.82 320.573L408.662 330.315V349.221L391.82 339.479V320.573Z",
    fill: "url(#paint20_linear)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M425.504 320.573L408.662 330.315V349.221L425.504 339.479V320.573Z",
    fill: "#C0162E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M408.662 310.831L391.82 320.573L408.662 330.315L425.504 320.573L408.662 310.831Z",
    fill: "url(#paint21_linear)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M370.025 341.625L386.867 351.367V389.674L370.025 379.932V341.625Z",
    fill: "#CACACB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M403.709 341.625L386.867 351.367V389.674L403.709 379.932V341.625Z",
    fill: "#F1ECEC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M386.867 331.884L370.025 341.626L386.867 351.367L403.709 341.626L386.867 331.884Z",
    fill: "#F1ECEC"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M370.025 341.625L386.867 351.367V361.935L370.025 352.193V341.625Z",
    fill: "#292929"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M403.709 341.625L386.867 351.367V361.935L403.709 352.193V341.625Z",
    fill: "#292929"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M386.867 331.884L370.025 341.626L386.867 351.367L403.709 341.626L386.867 331.884Z",
    fill: "#313131"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M348.148 331.801L364.99 341.543V402.223L348.148 392.481V331.801Z",
    fill: "#CACACB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M381.832 331.884L364.99 341.626V402.223L381.832 392.481V331.884Z",
    fill: "#F1ECEC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M364.99 322.307L348.148 331.966L364.99 341.708L381.832 331.966L364.99 322.307Z",
    fill: "#59595B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M326.352 384.803L343.193 394.463V414.772L326.352 405.03V384.803Z",
    fill: "#CACACB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M360.035 384.803L343.193 394.463V414.772L360.035 405.03V384.803Z",
    fill: "#F1ECEC"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M343.193 375.062L326.352 384.803L343.193 394.463L360.035 384.803L343.193 375.062Z",
    fill: "#F1ECEC"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M160.409 438.384L224.391 401.48L218.117 397.848L154.217 434.751L160.409 438.384Z",
    fill: "url(#paint22_linear)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M150.751 432.77L242.556 379.767L236.364 376.135L144.477 429.137L150.751 432.77Z",
    fill: "url(#paint23_linear)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M141.091 427.156L242.555 368.622L236.363 364.99L134.816 423.606L141.091 427.156Z",
    fill: "url(#paint24_linear)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M131.35 421.624L221.421 369.613L215.147 365.98L125.158 417.992L131.35 421.624Z",
    fill: "url(#paint25_linear)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M121.69 416.01L175.931 384.721L169.657 381.088L115.416 412.378L121.69 416.01Z",
    fill: "url(#paint26_linear)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 410.396L150.915 387.941L144.723 384.308L105.756 406.846L112.03 410.396Z",
    fill: "url(#paint27_linear)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M102.288 404.865L150.914 376.795L144.722 373.163L96.0957 401.233L102.288 404.865Z",
    fill: "url(#paint28_linear)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6299 399.251L146.375 368.209L140.183 364.577L86.3555 395.619L92.6299 399.251Z",
    fill: "url(#paint29_linear)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9697 393.637L154.382 352.358L148.191 348.808L76.6953 390.005L82.9697 393.637Z",
    fill: "url(#paint30_linear)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M73.229 388.023L158.264 338.984L151.989 335.351L67.0371 384.473L73.229 388.023Z",
    fill: "#C0162E"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5693 382.492L138.945 338.984L132.67 335.351L57.2949 378.859L63.5693 382.492Z",
    fill: "#C0162E"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9092 376.878L100.885 349.799L94.6103 346.166L47.6348 373.245L53.9092 376.878Z",
    fill: "#C0162E"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M44.251 371.264L106.83 335.103L100.556 331.471L37.9766 367.631L44.251 371.264Z",
    fill: "url(#paint31_linear)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5088 365.65L88.7495 334.36L82.4751 330.728L28.2344 362.1L34.5088 365.65Z",
    fill: "url(#paint32_linear)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M160.411 327.095C147.366 319.582 129.616 316.445 112.609 317.601C124.828 318.509 136.716 321.646 146.128 327.095C168.584 340.057 168.584 361.109 146.128 374.071C136.716 379.52 124.828 382.657 112.609 383.565C129.616 384.803 147.366 381.666 160.411 374.071C182.866 361.027 182.866 340.057 160.411 327.095Z",
    fill: "url(#paint33_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M82.64 327.095C92.0517 321.646 103.94 318.509 116.159 317.601C99.1517 316.363 81.4017 319.5 68.3575 327.095C45.9017 340.057 45.9017 361.109 68.3575 374.071C81.4017 381.584 99.1517 384.721 116.159 383.565C103.94 382.657 92.0517 379.52 82.64 374.071C60.1842 361.027 60.1842 340.057 82.64 327.095Z",
    fill: "url(#paint34_linear)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M149.513 327.095C126.975 314.051 90.3191 314.051 67.7807 327.095C45.2424 340.139 45.2424 361.274 67.7807 374.318C90.3191 387.363 126.975 387.363 149.513 374.318C172.052 361.274 172.052 340.139 149.513 327.095ZM142.743 370.438C123.92 381.336 93.3737 381.336 74.4679 370.438C55.6447 359.541 55.6447 341.956 74.4679 331.058C93.2912 320.16 123.838 320.16 142.743 331.058C161.649 341.873 161.649 359.541 142.743 370.438Z",
    fill: "#F1ECEC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M74.551 317.766C93.3743 306.868 123.921 306.868 142.827 317.766C155.21 324.949 159.421 334.938 155.541 344.102C153.477 339.314 149.266 334.773 142.827 331.058C124.003 320.16 93.4569 320.16 74.551 331.058C68.1115 334.773 63.8185 339.314 61.8371 344.102C57.8743 334.938 62.1673 324.866 74.551 317.766Z",
    fill: "#292929"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 321.894C124.003 310.996 93.4563 310.996 74.6331 321.894C55.8098 332.792 55.8098 350.377 74.6331 361.274C93.4563 372.172 124.003 372.172 142.826 361.274C161.732 350.377 161.732 332.792 142.826 321.894Z",
    fill: "#686A6D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5037 323.793C83.6316 321.151 90.4013 320.903 94.7769 323.132C99.0699 325.362 99.2351 329.324 95.1897 331.966C91.0618 334.608 84.292 334.856 79.9165 332.627C75.5409 330.398 75.3758 326.435 79.5037 323.793Z",
    fill: "#F1ECEC"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M100.144 319.005C101.877 317.931 104.684 317.766 106.418 318.757C108.234 319.665 108.234 321.316 106.583 322.39C104.849 323.463 102.042 323.628 100.309 322.637C98.5749 321.729 98.4924 320.078 100.144 319.005Z",
    fill: "#F1ECEC"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 323.875C124.003 312.978 93.4563 312.978 74.633 323.875C65.6342 329.077 60.9284 335.764 60.5156 342.616C60.1028 335.186 64.7261 327.591 74.633 321.894C93.4563 310.996 124.003 310.996 142.826 321.894C152.65 327.591 157.356 335.103 156.943 342.616C156.531 335.764 151.825 328.994 142.826 323.875Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M149.513 313.803C126.975 300.759 90.3191 300.759 67.7807 313.803C45.2424 326.848 45.2424 347.982 67.7807 361.027C90.3191 374.071 126.975 374.071 149.513 361.027C172.052 347.982 172.052 326.848 149.513 313.803ZM142.743 357.146C123.92 368.044 93.3737 368.044 74.4679 357.146C55.6447 346.249 55.6447 328.664 74.4679 317.766C93.2912 306.869 123.838 306.869 142.743 317.766C161.649 328.581 161.649 346.249 142.743 357.146Z",
    fill: "#313131"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7814 361.027C90.3198 374.071 126.976 374.071 149.514 361.027C160.659 354.587 166.273 346.166 166.438 337.745V350.377C166.603 359.045 160.99 367.714 149.514 374.318C126.976 387.363 90.3198 387.363 67.7814 374.318C56.3884 367.714 50.6919 359.045 50.857 350.377V337.828C51.0221 346.249 56.6361 354.587 67.7814 361.027Z",
    fill: "#292929"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M149.513 362.843C150.916 362.017 152.237 361.192 153.476 360.284L163.217 365.898L154.797 370.769L145.055 365.155C146.623 364.412 148.109 363.586 149.513 362.843Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M154.797 380.428L145.055 374.814V365.072L154.797 370.686V380.428Z",
    fill: "#313131"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M151.164 377.703C151.164 372.667 154.714 366.558 159.007 364.081C161.236 362.76 163.3 362.678 164.704 363.668L220.761 396.031L210.028 415.515L154.054 383.07C152.237 382.409 151.164 380.51 151.164 377.703Z",
    fill: "#292929"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M158.347 385.546L161.071 387.115C159.915 386.207 159.172 384.556 159.172 382.327C159.172 377.291 162.722 371.181 167.015 368.704C169.244 367.384 171.308 367.301 172.712 368.292L168.997 366.145C167.593 365.237 165.529 365.32 163.3 366.558C158.924 369.035 155.457 375.144 155.457 380.18C155.457 383.07 156.613 384.886 158.347 385.546Z",
    fill: "url(#paint35_linear)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M208.789 414.689C210.606 415.928 212.752 416.671 215.064 416.671C221.173 416.671 226.209 411.717 226.209 405.526C226.209 401.315 223.897 397.682 220.43 395.784C219.027 395.123 217.128 395.206 215.064 396.444C210.688 398.921 207.221 405.03 207.221 410.066C207.221 412.213 207.881 413.864 209.037 414.772L208.789 414.689Z",
    fill: "#292929"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M350.788 432.605L329.819 420.469V414.277H319.004L298.034 402.141C295.887 400.902 292.42 400.902 290.191 402.141L258.241 420.551C256.094 421.79 256.094 423.853 258.241 425.092L310.995 455.556C311.573 455.886 312.234 456.134 312.894 456.299L312.151 456.546H315.041C316.362 456.546 317.765 456.216 318.756 455.638L350.706 437.228C352.935 435.907 352.935 433.843 350.788 432.605Z",
    fill: "url(#paint36_linear)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M327.176 418.652V412.46H316.361L295.391 400.324C293.245 399.086 289.777 399.086 287.548 400.324L255.598 418.735C253.452 419.973 253.452 422.037 255.598 423.275L308.353 453.739C310.499 454.978 313.967 454.978 316.196 453.739L348.146 435.329C350.292 434.091 350.292 432.027 348.146 430.788L327.176 418.652Z",
    fill: "url(#paint37_linear)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M286.558 417.909L289.777 419.725L287.879 420.799L284.659 418.982L281.026 421.129L279.045 419.973L282.677 417.827L279.458 415.928L281.357 414.855L284.576 416.753L287.961 414.772L289.943 415.928L286.558 417.909Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M290.191 427.816L288.127 426.66L298.034 420.964L293.989 419.808L295.722 418.817L302.244 420.551L302.492 420.716L290.191 427.816Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M301.088 427.073L307.94 423.853L314.545 427.651L312.811 428.642L307.94 425.835L304.638 427.321C305.546 427.486 306.371 427.734 307.032 428.146C308.188 428.807 308.765 429.55 308.6 430.375C308.518 431.201 307.857 431.944 306.536 432.687C305.298 433.43 303.895 433.76 302.491 433.76C301.005 433.76 299.684 433.43 298.446 432.687C297.29 432.027 296.712 431.284 296.629 430.541C296.547 429.715 296.96 429.055 297.95 428.394L299.932 429.55C299.436 429.963 299.189 430.293 299.189 430.706C299.189 431.118 299.519 431.449 300.097 431.779C300.757 432.109 301.418 432.274 302.243 432.274C303.069 432.192 303.812 431.944 304.638 431.531C305.381 431.118 305.793 430.623 305.793 430.128C305.876 429.632 305.546 429.22 304.803 428.807C304.39 428.559 304.06 428.477 303.729 428.312C303.399 428.229 302.904 428.146 302.326 428.146L301.088 427.073Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M314.131 430.21C314.874 429.798 315.7 429.55 316.69 429.55C317.681 429.55 318.507 429.798 319.25 430.21C320.075 430.706 320.405 431.201 320.405 431.696C320.405 432.274 319.993 432.77 319.25 433.183L318.672 433.513C317.929 433.925 317.103 434.173 316.112 434.173C315.122 434.173 314.296 433.925 313.553 433.513C312.81 433.1 312.397 432.605 312.397 432.027C312.397 431.449 312.727 430.953 313.553 430.541L314.131 430.21ZM314.874 431.366C314.461 431.614 314.296 431.862 314.213 432.109C314.213 432.357 314.379 432.605 314.709 432.852C315.039 433.017 315.452 433.182 315.947 433.1C316.36 433.1 316.855 432.935 317.268 432.687L317.846 432.357C318.259 432.109 318.424 431.862 318.506 431.614C318.506 431.366 318.341 431.119 318.011 430.871C317.681 430.706 317.268 430.541 316.773 430.623C316.277 430.623 315.865 430.788 315.452 431.036L314.874 431.366ZM308.104 437.145L307.691 436.155L323.295 434.091L323.708 435.081L308.104 437.145ZM313.14 437.558C313.883 437.145 314.791 436.898 315.7 436.898C316.69 436.898 317.516 437.145 318.259 437.558C319.002 437.971 319.415 438.466 319.415 439.044C319.415 439.622 319.084 440.117 318.259 440.53L317.681 440.86C316.938 441.273 316.112 441.521 315.204 441.521C314.296 441.521 313.388 441.273 312.562 440.86C311.737 440.365 311.407 439.87 311.324 439.374C311.324 438.796 311.654 438.301 312.48 437.888L313.14 437.558ZM313.883 438.796C313.47 439.044 313.305 439.292 313.305 439.539C313.305 439.787 313.47 440.035 313.801 440.282C314.131 440.53 314.544 440.613 315.039 440.53C315.452 440.53 315.947 440.365 316.36 440.117L317.02 439.787C317.433 439.539 317.598 439.292 317.598 439.044C317.598 438.796 317.433 438.549 317.103 438.384C316.773 438.219 316.36 438.053 315.865 438.136C315.452 438.136 314.957 438.301 314.544 438.549L313.883 438.796Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M348.146 435.246L316.196 453.739C314.05 454.978 310.582 454.978 308.353 453.739L255.598 423.276C254.525 422.615 253.947 421.789 253.947 420.964V422.945C253.947 423.771 254.525 424.514 255.598 425.092L308.353 455.556C310.5 456.794 313.967 456.794 316.196 455.556L348.146 437.145C349.219 436.567 349.715 435.742 349.797 434.916V434.834V432.935C349.797 433.843 349.219 434.669 348.146 435.246Z",
    fill: "#C0162E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M246.599 45.2419L250.644 52.2593L254.69 49.9477L270.376 59.0291C272.027 59.9372 273.265 59.1942 273.265 57.3779V29.7209C273.265 27.8221 271.944 25.593 270.376 24.6849L230.913 1.8163C229.262 0.90816 228.023 1.65118 228.023 3.46746V31.0419C228.023 32.9407 229.344 35.1698 230.913 36.0779L246.599 45.2419Z",
    fill: "url(#paint38_linear)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M237.6 28.6477L236.032 27.7396V19.2361L233.803 18.8233V17.3373L237.353 17.9152L237.518 17.9977V28.6477H237.6Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M241.15 33.106L240.324 32.0327C240.572 31.7025 240.737 31.4548 240.82 31.2071C240.902 30.9595 240.985 30.6292 240.985 30.299V28.8955L242.388 29.7211V30.9595C242.388 31.4548 242.306 31.9502 242.058 32.2804C241.728 32.6932 241.48 32.9409 241.15 33.106Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M249.818 35.7479L243.627 32.1979V30.9595L246.681 28.8956C247.094 28.5653 247.424 28.3176 247.589 27.9874C247.754 27.7397 247.837 27.4095 247.837 26.9967C247.837 26.5014 247.754 26.006 247.507 25.5932C247.259 25.1804 246.929 24.7676 246.516 24.52C246.021 24.2723 245.608 24.1897 245.36 24.3549C245.113 24.52 244.948 24.9328 244.948 25.5932L243.379 24.6851C243.379 24.0246 243.544 23.5293 243.792 23.1165C244.039 22.7862 244.452 22.5386 244.865 22.5386C245.36 22.5386 245.856 22.7037 246.516 23.0339C247.424 23.5293 248.085 24.1897 248.663 25.0153C249.158 25.8409 249.406 26.6665 249.406 27.5746C249.406 28.07 249.241 28.5653 248.993 28.9781C248.745 29.3909 248.332 29.8037 247.755 30.2165L245.525 31.7025L249.818 34.1793V35.7479Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M253.286 34.3442L252.625 34.757V37.3163L251.057 36.4082V25.2628L252.625 26.171V32.6105L253.121 32.1977L255.019 30.7942L256.836 31.8675L254.276 33.6837L257.083 39.8756L255.267 38.8849L253.286 34.3442Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M265.422 42.0222C265.422 41.6094 265.339 41.1966 265.091 40.7838C264.844 40.371 264.513 39.9582 263.936 39.3803C263.44 38.885 263.027 38.3896 262.697 38.0594C261.706 36.9036 261.211 35.6652 261.211 34.5094C261.211 33.6838 261.459 33.1885 261.872 32.8582C262.284 32.6106 262.862 32.6106 263.605 32.9408V31.3722L264.596 31.9501V33.5187C265.339 34.0966 265.917 34.7571 266.33 35.5827C266.742 36.4082 266.908 37.3164 266.908 38.2245L265.339 37.3164C265.339 36.7385 265.256 36.1606 265.009 35.6652C264.761 35.1699 264.431 34.8396 264.018 34.592C263.605 34.3443 263.275 34.2617 263.11 34.4268C262.862 34.5094 262.78 34.8396 262.78 35.335C262.78 35.7478 262.862 36.1606 263.11 36.5734C263.358 36.9861 263.688 37.3989 264.266 37.9768C264.844 38.5547 265.256 38.9675 265.504 39.3803C265.834 39.7931 266.082 40.1234 266.247 40.5361C266.495 40.9489 266.66 41.2792 266.742 41.692C266.825 42.1047 266.908 42.5175 266.908 42.9303C266.908 43.7559 266.66 44.3338 266.247 44.5815C265.834 44.8292 265.174 44.8292 264.431 44.4164V45.8199L263.44 45.242V43.7559C262.615 43.178 261.954 42.435 261.541 41.6094C261.129 40.7838 260.881 39.8757 260.881 38.885L262.449 39.7931C262.449 40.371 262.615 40.9489 262.862 41.4443C263.11 41.9396 263.523 42.3524 264.018 42.6001C264.513 42.8478 264.844 42.9303 265.091 42.8478C265.339 42.6827 265.422 42.435 265.422 42.0222Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M272.936 23.1988L233.39 0.412802C232.565 -0.082547 231.904 -0.082547 231.326 0.165127L228.85 1.56862C229.345 1.32094 230.088 1.32094 230.914 1.81629L270.376 24.6023C272.027 25.5105 273.266 27.8221 273.266 29.6384V57.2128C273.266 58.1209 272.936 58.7814 272.44 59.0291L274.917 57.7907C274.917 57.7907 274.917 57.7907 275 57.7907C275.495 57.4605 275.825 56.8 275.825 55.9744V28.2349C275.825 26.4186 274.504 24.107 272.936 23.1988Z",
    fill: "#C0162E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M24.931 205.405C26.1694 206.148 26.417 209.12 26.417 210.523L17.3357 205.24C17.3357 203.836 17.0054 200.781 15.8496 200.121L24.931 205.405Z",
    fill: "#59595B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9673 167.758L48.0487 173.042C46.8103 173.785 44.0034 175.023 42.765 174.363L33.6836 169.079C34.922 169.822 37.7289 168.501 38.9673 167.758Z",
    fill: "#59595B"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5671 190.627C23.9427 188.15 27.4101 182.041 27.4101 177.087C27.4101 174.611 26.502 172.877 25.0985 172.051L34.1799 177.335C35.5834 178.161 36.4915 179.894 36.4915 182.371C36.4915 187.325 33.0241 193.434 28.6485 195.911C26.502 197.149 24.5206 197.314 23.0345 196.488L13.9531 191.205C15.3566 191.948 17.338 191.865 19.5671 190.627Z",
    fill: "url(#paint39_linear)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08139 195.58L9.16395 200.699L0 195.415V190.297L9.08139 195.58Z",
    fill: "#CACACB"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6314 157.934L30.7954 163.218L26.3373 165.777L17.2559 160.493L21.6314 157.934Z",
    fill: "#CACACB"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77907 184.187C6.02674 183.362 6.27442 182.454 6.52209 181.628C7.51279 179.069 5.20116 177.005 4.12791 176.427L13.2093 181.71C14.2826 182.371 16.5942 184.352 15.6035 186.912C15.2733 187.737 15.0256 188.645 14.8605 189.471C14.3651 192.03 10.5674 194.672 9.08139 195.58L0 190.297C1.48605 189.471 5.28372 186.747 5.77907 184.187Z",
    fill: "#59595B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M12.054 171.308C12.3842 171.143 12.7145 170.813 13.0447 170.4C13.6226 169.74 14.2831 169.079 14.861 168.501C16.8424 166.768 17.2552 162.227 17.2552 160.493L26.3365 165.777C26.3365 167.511 25.9238 172.051 23.9424 173.785C23.2819 174.363 22.704 175.023 22.1261 175.684C21.7959 176.097 21.4656 176.344 21.1354 176.592C19.4017 177.583 17.3377 176.757 16.347 176.344L7.26562 171.061C8.17376 171.473 10.3203 172.299 12.054 171.308Z",
    fill: "url(#paint40_linear)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6862 201.772C16.7594 203.176 14.3652 207.964 13.292 209.78L16.4292 211.597C17.3373 210.11 19.4838 206.808 21.2175 205.817C21.5478 205.57 21.878 205.487 22.2082 205.57C22.7862 205.57 23.4466 205.487 24.0245 205.405C26.0059 204.827 26.4187 208.955 26.4187 210.688L30.8768 208.129C30.8768 206.395 31.2896 202.267 33.271 200.121C33.9315 199.543 34.5094 198.883 35.0873 198.222C35.4175 197.809 35.7478 197.562 36.078 197.314C37.8117 196.323 39.9582 197.066 40.8664 197.644L44.0036 192.278C42.9303 191.7 40.5361 189.636 41.6094 186.994C41.9396 186.169 42.1873 185.26 42.3524 184.435C42.8478 181.876 46.6454 179.234 48.1315 178.326V173.207C46.6454 174.115 42.8478 175.766 42.3524 173.785C42.1047 173.207 41.8571 172.629 41.6094 172.134C40.5361 170.73 42.7652 166.024 44.0036 164.126L40.8664 162.309C39.9582 163.795 37.8117 167.098 36.078 168.088C35.7478 168.336 35.335 168.419 35.0873 168.336C34.5094 168.336 33.8489 168.419 33.271 168.501C31.2896 169.079 30.8768 164.951 30.8768 163.217L26.4187 165.777C26.4187 167.51 26.0059 172.051 24.0245 173.785C23.3641 174.363 22.7862 175.023 22.2082 175.684C21.878 176.097 21.5478 176.344 21.2175 176.592C19.4838 177.583 17.4199 176.757 16.4292 176.344L13.292 181.71C14.3652 182.288 16.7594 184.352 15.6862 186.994C15.3559 187.82 15.1082 188.728 14.9431 189.554C14.4478 192.113 10.6501 194.755 9.16406 195.663V200.781C10.6501 199.873 14.4478 198.222 14.9431 200.203C15.1082 200.699 15.3559 201.277 15.6862 201.772ZM20.8048 191.37C20.8048 186.416 24.2722 180.307 28.6478 177.83C33.0234 175.353 36.4908 177.335 36.4908 182.288C36.4908 187.242 33.0234 193.351 28.6478 195.828C24.3548 198.387 20.8048 196.406 20.8048 191.37Z",
    fill: "#CACACB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16442 200.699C10.6505 199.791 14.4481 198.14 14.9435 200.121C15.1912 200.699 15.4388 201.277 15.6865 201.772C16.7598 203.176 14.3656 207.964 13.2923 209.78L4.21094 204.497C4.8714 203.341 6.02722 201.112 6.52256 199.213L9.16442 200.699Z",
    fill: "#59595B"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26416 170.978L16.3456 176.344L13.2083 181.71L4.12695 176.427L7.26416 170.978Z",
    fill: "#CACACB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7023 156.861L40.7837 162.144C39.8756 163.63 37.7291 166.933 35.9954 167.923C35.6651 168.171 35.2523 168.254 35.0047 168.171C34.4268 168.171 33.7663 168.254 33.1884 168.336C31.207 168.914 30.7942 164.786 30.7942 163.052L28.1523 161.566C29.5558 160.245 31.0419 158.099 31.7023 156.861Z",
    fill: "#59595B"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3477 85.6952V120.617L57.0488 138.12C57.0488 118.884 70.5884 95.3545 87.3477 85.6952Z",
    fill: "#7F7FF2"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6504 82.4755L102.372 94.4464L72.6516 147.201L51.3516 134.9C51.3516 115.581 64.8911 92.0522 81.6504 82.4755Z",
    fill: "#313131"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3477 85.6952V120.617L57.0488 138.12C57.0488 118.884 70.5884 95.3545 87.3477 85.6952Z",
    fill: "#292929"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0488 138.202L87.3477 120.7L60.5163 152.402C58.2872 148.852 57.0488 144.064 57.0488 138.202Z",
    fill: "#59595B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M87.347 120.7V85.7778C104.106 76.1185 117.646 83.9615 117.646 103.28C117.646 122.599 104.106 146.045 87.347 155.705C75.7063 162.392 65.6342 160.658 60.5156 152.485L87.347 120.7Z",
    fill: "url(#paint41_linear)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6504 82.4755C90.0713 77.6045 97.6667 77.1917 103.116 80.4115L108.482 83.4661C103.033 80.4941 95.6027 80.9894 87.3469 85.7778L81.6504 82.4755Z",
    fill: "url(#paint42_linear)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6893 154.136C57.7905 152.898 56.1393 151.246 54.8184 149.1L60.5149 152.402C61.8358 154.549 63.487 156.2 65.3858 157.438L59.6893 154.136Z",
    fill: "url(#paint43_linear)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M54.819 149.1C52.5899 145.55 51.3516 140.762 51.3516 134.9L57.0481 138.202C57.0481 144.064 58.2864 148.852 60.5155 152.402L54.819 149.1Z",
    fill: "url(#paint44_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 415.969,
    y1: 68.176,
    x2: 415.969,
    y2: 246.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 137.994,
    y1: 223.402,
    x2: 137.994,
    y2: 235.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 213.162,
    y1: 192.36,
    x2: 213.162,
    y2: 204.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 173.867,
    y1: 207.881,
    x2: 173.867,
    y2: 220.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 482.593,
    y1: 297.292,
    x2: 482.593,
    y2: 341.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 490.186,
    y1: 300.099,
    x2: 490.186,
    y2: 318.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 475.677,
    y1: 311.547,
    x2: 473.797,
    y2: 302.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 475.688,
    y1: 308.189,
    x2: 475.687,
    y2: 291.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 475.659,
    y1: 309.304,
    x2: 475.659,
    y2: 296.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 58.6973,
    y1: 217.541,
    x2: 58.6973,
    y2: 272.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 250.677,
    y1: 191.039,
    x2: 250.677,
    y2: 373.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 316.309,
    y1: 243.236,
    x2: 279.609,
    y2: 158.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 250.108,
    y1: 80.2466,
    x2: 250.108,
    y2: 220.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 167.097,
    y1: 75.4404,
    x2: 147.681,
    y2: 90.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 216.054,
    y1: 129.516,
    x2: 196.638,
    y2: 144.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 119.542,
    y1: 220.884,
    x2: 119.542,
    y2: 208.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 420.014,
    y1: 370.191,
    x2: 420.014,
    y2: 389.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 396.734,
    y1: 382.739,
    x2: 396.734,
    y2: 402.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 372.421,
    y1: 395.288,
    x2: 372.421,
    y2: 414.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 441.809,
    y1: 357.724,
    x2: 441.809,
    y2: 377.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 400.211,
    y1: 349.221,
    x2: 400.211,
    y2: 320.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 408.601,
    y1: 330.315,
    x2: 408.601,
    y2: 310.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 189.304,
    y1: 397.848,
    x2: 189.304,
    y2: 438.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 193.516,
    y1: 376.135,
    x2: 193.516,
    y2: 432.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 188.686,
    y1: 364.99,
    x2: 188.686,
    y2: 427.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 173.29,
    y1: 365.98,
    x2: 173.29,
    y2: 421.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 145.674,
    y1: 381.088,
    x2: 145.674,
    y2: 416.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 128.336,
    y1: 384.308,
    x2: 128.336,
    y2: 410.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 123.505,
    y1: 373.163,
    x2: 123.505,
    y2: 404.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 116.365,
    y1: 364.577,
    x2: 116.365,
    y2: 399.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 115.539,
    y1: 348.808,
    x2: 115.539,
    y2: 393.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 72.4033,
    y1: 331.471,
    x2: 72.4033,
    y2: 371.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 58.4919,
    y1: 330.728,
    x2: 58.4919,
    y2: 365.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 144.931,
    y1: 317.368,
    x2: 144.931,
    y2: 383.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 83.8371,
    y1: 317.338,
    x2: 83.8371,
    y2: 383.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 164.084,
    y1: 365.536,
    x2: 164.084,
    y2: 387.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 304.509,
    y1: 401.212,
    x2: 304.509,
    y2: 456.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 301.699,
    y1: 454.668,
    x2: 301.699,
    y2: 399.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 250.563,
    y1: 59.4167,
    x2: 250.563,
    y2: 1.42871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 36.4915,
    y1: 182.408,
    x2: 6.39133,
    y2: 207.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 26.3366,
    y1: 167.371,
    x2: 6.0483,
    y2: 188.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 89.0807,
    y1: 81.6431,
    x2: 89.0807,
    y2: 159.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 95.0661,
    y1: 78.338,
    x2: 95.0661,
    y2: 85.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 60.1021,
    y1: 149.1,
    x2: 60.1021,
    y2: 157.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 60.5155,
    y1: 142.166,
    x2: 43.7039,
    y2: 150.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPresentationHero);
export default __webpack_public_path__ + "static/media/data_presentation_hero.b75386109564ffcc25f4653ab56df89e.svg";
export { ForwardRef as ReactComponent };